import "./Home.css";
import Video from "../images/FirstPageImage.png";
import SecondPageLogo1 from "../images/SecondPageLogos1.jpg";
import SecondPageLogo2 from "../images/SecondPageLogos2.png";
import Emblem from "../images/EmblemeChatzikGikasHigh.jpg";
import MicroscopeIcon from "../images/MicroscopeIcon.png";
import HeadIcon from "../images/HeadIcon.png";
import BarIcon from "../images/PlotIcon.png";

function Home() {
  return (
    <div>
      <section id="FirstPage">
        {/* ---------------------------------------- First Pagae----------------------------------------------- */}

        <div className="section-container">
          <div className="container">
            <div className="row">
              <div className="col-lg-7">
                <div id="FirstPageText">
                  <h3 style={{ marginBottom: "5%" }}>
                    Πληροφόρηση για Συνδυασμένες Μετακινήσεις
                  </h3>

                  <p>
                    Η υπηρεσία πληροφόρησης για συνδυασμένες μετακινήσεις
                    δημιουργήθηκε στο πλαίσιο της Ερευνητικής Υποδομής
                    EN.I.R.I.S.S.T. (Intelligent Research Infrastructure,
                    Shipping, Supply Chain, Transport and Logistics) και
                    συγκεκριμένα της "Πλατφόρμας Επιβατικών Μετακινήσεων".
                  </p>

                  <p>
                    Εδώ μπορείς να βρεις πληροφορίες για απευθείας μετακινήσεις
                    ή μετακινήσεις με ενδιάμεσο προορισμό μεταξύ κύριων
                    προορισμών της χώρας, με συνδυασμό όλων των διαθέσιμων μέσων
                    μετακίνησης. Επιπλέον, παρέχεται η δυνατότητα για εύρεση της
                    βέλτιστης αλυσίδας μετακίνησης ανά ζεύγος προορισμού, βάσει
                    χρόνου, κόστους και περιβαλλοντικού αντίκτυπου της
                    μετακίνησης.
                  </p>
                </div>
              </div>
              <div className="col-lg-5" id="VideoPos">
                <img src={Video} width="400" height="400" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ----------------------------------------------------- SECTION 2 OF PAGE 1------------------------------ */}
      <div className="container-fluid" id="PlatformLink">
        <hr
          style={{ height: "2px", width: "20%", backgroundColor: "orange" }}
        ></hr>
        <h3>
          <strong>Υπηρεσία για Συνδυασμένες Μετακινήσεις</strong>
        </h3>
        <p style={{ width: 400 }}>
          Η υπηρεσία πληροφόρησης για συνδυασμένες μετακινήσεις ενημερώνει τον
          χρήστη για μετακινήσεις μεταξύ κύριων προορισμών στην Ελλάδα και
          συγκεκριμένα για:
        </p>
      </div>

      <div
        className="container"
        style={{ backgroundColor: "rgba(173, 216, 230, 0.5)", height: "500" }}
      >
        <div className="row">
          <div className="col-lg-4 box">
            <div className="card" style={{ height: 300, marginTop: "5%" }}>
              <div style={{ display: "flex" }}>
                <img
                  src={MicroscopeIcon}
                  style={{ width: 60, height: 50, marginRight: 10 }}
                  alt=""
                />
                <div>
                  <h4 style={{ color: "blue" }}>Βήμα 1</h4>
                </div>
              </div>
              <p>Επιλογές απευθείας σύνδεσης</p>
              <p>
                {" "}
                Για κύρια ζεύγη προέλευσης-προορισμού εμφανίζονται οι διαθέσιμες
                απευθείας συνδέσεις για όλα τα μέσα μετακίνησης.
              </p>
            </div>
          </div>
          <div className="col-lg-4 box">
            <div className="card" style={{ height: 300, marginTop: "5%" }}>
              <div style={{ display: "flex" }}>
                <img
                  src={HeadIcon}
                  style={{ width: 60, height: 50, marginRight: 10 }}
                  alt=""
                />
                <div>
                  <h4 style={{ color: "blue" }}>Βήμα 2</h4>
                </div>
              </div>
              <p>Επιλογές με ενδιάμεσο προορισμό</p>
              <p>
                {" "}
                Παρέχεται στον χρήστη πληροφόρηση σχετικά με όλα τα σκέλη μιας
                αλυσίδας μετακίνησης, η οποία απαιτεί τον συνδυασμό περισσότερων
                του ενός μέσων μετακίνησης.
              </p>
            </div>
          </div>
          <div className="col-lg-4 box">
            <div
              className="card"
              style={{ height: 300, marginBottom: "10%", marginTop: "5%" }}
            >
              <div style={{ display: "flex" }}>
                <img
                  src={BarIcon}
                  style={{ width: 60, height: 50, marginRight: 10 }}
                  alt=""
                />
                <div>
                  <h4 style={{ color: "blue" }}>Βήμα 3</h4>
                </div>
              </div>
              <p>Την βέλτιστη αλυσίδα μετακίνησης</p>
              <p>
                {" "}
                Για όλες τις πιθανές αλυσίδες μετακίνησης σε ένα ζεύγος
                προέλευσης-προορισμού, υπολογίζεται το συνολικό κόστος, ο
                συνολικός χρόνος και η συνολική περιβαλλοντική επιβάρρυνση και
                εμφανίζεται στον χρήστη η βέλτιστη αλυσίδα ανάλογα με το
                κριτήριο που επιλέγει.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container" id="MidSection">
        <div className="row">
          <div className="col-lg-7">
            <div style={{ marginTop: "40%" }}>
              <h3>
                <strong> Εταίροι Ανάπτυξης Υπηρεσίας</strong>
              </h3>

              <p>
                Η Υπηρεσία Πληροφόρησης για Συνδυασμένες Μετακινήσεις
                αναπτύχθηκε από την ερευνητική ομάδα του Εργαστηρίου
                Συγκοινωνιακής Τεχνικής του Τομέα Μεταφορών και Διαχείρισης
                Έργων του Αριστοτελείου Πανεπιστημίου Θεσσαλονίκης και την
                ερευνητική ομάδα του Εργαστηρίου Σιδηροδρομικής και Μεταφορών
                του Τμήματος Πολιτικών Μηχανικών του Εθνικού Μετσοβίου
                Πολυτεχνείου.
              </p>
            </div>
          </div>
          <div className="col-lg-5" style={{ marginTop: "5%" }}>
            <img src={SecondPageLogo2} width="550" height="250" alt="" />
            <div style={{ display: "flex" }}>
              <img
                style={{ marginLeft: "25%" }}
                src={SecondPageLogo1}
                width="200"
                height="150"
                alt=""
              />
              <img
                style={{ marginLeft: "20%" }}
                src={Emblem}
                width="200"
                height="150"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
